import React from 'react';
import * as signalR from "@microsoft/signalr";
import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux/es/exports";
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { useOutsideClick } from "./customHooks/useOutsideClick";
import CompletedTodosPage from './Pages/CompletedTasksPage/CompletedTodosPage';
import DeletedTodosPage from './Pages/DeletedTasksPage/DeletedTodosPage';
import IncomingTodosPage from './Pages/IncomingTasksPage/IncomingTodosPage';
import LoginPage from './Pages/Login/LoginPage';
import RegisterPage from './Pages/Register/RegisterPage';
import TodayTask from './Pages/TodayTasks/TodayTasksPage';
import OffcanvasMobile from './OffcanvasMobile/offcanvasMobileApp';
import NotFoundPage from './Pages/NotFoundPage/NotFoundPage';
import LabelPage from './Pages/Tags/TagsPage';
import Settings from './Pages/SettingsPage/SettingsPage';
import ForgotPassword from './Pages/ForgotPassword/ForgotPassword';
import { getAvatar} from "./asyncActions/avatarService";
import logo from './icons/svg/logo_timetask.svg';
import DDMenu from './DropDownMenu/DDMenu';
import './App.css';
import ResetPassword from './Pages/ResetPassword/ResetPassword';
// import TaskSelection from "./GroupTaskEditing/TaskSelection";
import CalendarPage from './Pages/CalendarPage/CalendarPage';
import SuccessPage from './Pages/SuccessPage/SuccessPage';
import { ReactComponent as BurgerMenu } from "../src/icons/svg/menu_ic/burger_menu_mobile.svg";
import { ReactComponent as ArrowDown } from "../src/icons/svg/menu_ic/arrow_down_pagePicker.svg";
import DDselectPage from './DropDownMenu/SelectPageMobile/DDselectPage';
import { ReactComponent as CalendarSvg } from "./icons/svg/submenu_ic/calendar-active.svg";
import { ReactComponent as TodaySvg } from "./icons/svg/submenu_ic/element-1-active.svg";
import { ReactComponent as IncomingSvg } from "./icons/svg/submenu_ic/filled-active.svg";
import EditModalTask from './ModalWindow/EditTaskModal/EditModalTask';
import Button from './UIcomponents/Button/Button';
import request from './Requests/requests';
import { loadUserSettings } from './store/settingsReducer';
import Privacy from './Privacy/privacy';
import { connectionHubContext } from './Context/connectionHubContext';
import Feedback from './Feedback/Feedback';
import Loader from './Loader/Lodaer';
import RepeatTemplatePage from './Pages/RepeatTemplatePage/RepeatTemplatePage';
import SuccessGoogle from './Pages/SuccessGoogle/SuccessGoogle';
import useTimeZone from './customHooks/useTimeZone';
import ModalWindow from './ModalWindow/ModalWindow/ModalWindow';
import SuccessAuth from './Pages/Login/AuthVariants/AuthStatusPage/SuccessAuth';
import EPG from './UIcomponents/EventPictureGenerator/EventPictureGenerator';
import ConverterUTC from './ConverterUTC/ConverterUTC';
import ProtectedRoutes from './components/routes/protectetRoutes';
import Cookies from 'universal-cookie';
import { getUserData } from './features/user/getUserData';
import { RootState } from './store';
import { MenuPageSelect, SettingsUserState } from './Types/Types';
import { UserAuthActionTypes } from './features/user/userStore';

function App() {
  localStorage.setItem('interceptorTry', 'false');
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const prodHidden = process.env.REACT_APP_IS_DEV === 'true';
  const ref = useRef<HTMLButtonElement>(null);
  const [menuActiv, setMenuActiv] = useState(false);
  const [menuPage, setMenuPage] = useState(false);
  const [pageName, setPageName] = useState({ pageName: 'Мой день', index: 0 });
  const [windowScreen, setWindowScreen] = useState(window.screen.width);
  const [isDisabledHeaderBtns, setIsDisabledHeaderBtns] = useState(true);
  const userSettings = useSelector((state: SettingsUserState) => state.settings.settings);
  const { loading, isAuth } = useSelector((state: RootState ) => state.userAuthSettings)
  const { currentTimeZoneId } = userSettings;
  // const { isAuth, setIsAuth, loader} = useAuthToken();
  const cookies = new Cookies();
  const {checkCurrentTimeZone, getCurrentTimeZone, getDetectedTimeZone} = useTimeZone(new Date(), currentTimeZoneId ?? '', 'longGeneric', 'ru-RU')
  const [loadingDecline, setLoadingDecline] = useState(false);
    const [loadingAccept, setLoadingAccept] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const currentTimeZone = -new Date().getTimezoneOffset() / 60;
    const stylesForBtnDiv = {
        width: '100%', 
        display: "flex", 
        flexDirection: "row", 
        justifyContent: "flex-end", 
        alignItems: "center",
        marginTop: '12px', 
        gap: '8px'
    }
  const [editTaskModalIcon, setEditTaskModalIcon] = useState(null);
  const urlTimerHub = (process.env.REACT_APP_API_BASEURL_HUB ?? 'https://api-demo.timetask.ru/') + 'TimerHub';
  const urlUpdateHub = (process.env.REACT_APP_API_BASEURL_HUB ?? 'https://api-demo.timetask.ru/') + 'TaskUpdateHub';
  const [connectionTimerHub, setConnectionTimerHub] = useState(null);
  const [connectionUpdateHub, setConnectionUpdateHub] = useState(null);
  const location = useLocation();
  const updatePageName = (payload: { pageName: string; index: number; }) => {
    setPageName({
      pageName: payload.pageName,
      index: payload.index
    })
  }  
  console.log(editTaskModalIcon);
  
  const arraySvg = [
    <TodaySvg style={{fill: '#5932EA', width: '16px', height: '16px' }} />,
    <CalendarSvg style={{stroke: '#5932EA', width: '16px', height: '16px' }} />,
    <IncomingSvg style={{fill: '#5932EA', width: '16px', height: '16px' }} />
  ];

  const arrayPages: MenuPageSelect[] = [
    {img: <TodaySvg fill='#232360' style={{width: '16px', height: '16px'}}/>, title: 'Мой день'},
    {img: <CalendarSvg stroke='#232360' style={{width: '16px', height: '16px'}} />, title: 'Календарь'},
    {img: <IncomingSvg fill='#232360' style={{width: '16px', height: '16px'}} />, title: 'Входящие задачи'}
  ]
  const arrayLink = ['/', '/calendar', '/viewlist'];
  let avaUrl = useSelector(state => state.settings.avatarUrl);
  useOutsideClick(ref, () => setMenuActiv(false), menuActiv);
  // const clearSelect = event => {
  //   if(event.ctrlKey){
  //       return;
  //   }else{
  //       TaskSelection("clear");
  //       return;
  //   }
  // }
  const refCloseSelectPage = useRef<HTMLDivElement>(null);
  useOutsideClick(refCloseSelectPage, () => setMenuPage(false), menuPage);

  const handleDeclineNewTimeZone = () => {
    setLoadingDecline(true)
    request.put('/Settings/', {
        userId: localStorage.getItem('userID'),
        currentTimeZoneId: getCurrentTimeZone(),
        timeZoneId: userSettings.timeZoneId,
        settingsType: userSettings.settingsType,
        isSmartDateRecognition: userSettings.isSmartDateRecognition,
        isTimeTracking: userSettings.isTimeTracking,
        timeZone: userSettings.timeZone,
        currentTimeZone: userSettings.currentTimeZone,
        isGCalendarIntegrated: userSettings.isGCalendarIntegrated
    })
    .then((response) => dispatch(loadUserSettings({...response.data, 
                                                    currentTimeZoneId: response.data.currentTimeZoneId, 
                                                    timeZoneId: userSettings.timeZoneId})))
    .then(() => setLoadingDecline(false))
    .then(() => setModalShow(false));
} 

const handleAddNewTimeZone = () => {
    setLoadingAccept(true)
    request.put('/Settings/', {
        userId: localStorage.getItem('userID'),
        currentTimeZoneId: getCurrentTimeZone(),
        timeZoneId: getCurrentTimeZone(),
        settingsType: userSettings.settingsType,
        isSmartDateRecognition: userSettings.isSmartDateRecognition,
        isTimeTracking: userSettings.isTimeTracking,
        timeZone: userSettings.timeZone,
        currentTimeZone: userSettings.currentTimeZone,
        isGCalendarIntegrated: userSettings.isGCalendarIntegrated
    })
    .then((response) => dispatch(loadUserSettings({...response.data, 
                                                    currentTimeZoneId: response.data.currentTimeZoneId, 
                                                    timeZone: response.data.timeZoneId})))
    .then(() => setLoadingAccept(false))
    .then(() => setModalShow(false));
}

useEffect(() => {
  if (checkCurrentTimeZone()) {
  } else {
      setModalShow(true)
  }
  /* eslint-disable-next-line react-hooks/exhaustive-deps */
}, [currentTimeZoneId, userSettings, currentTimeZone])

  /*Set connection to hub*/
const connectHub = (url: string, hubName: string) => {
  return new signalR.HubConnectionBuilder()
    .withUrl(url, {
      transport: signalR.HttpTransportType.LongPolling
    })
    .withAutomaticReconnect({
      nextRetryDelayInMilliseconds: (retryContext) => {
        return 60000;
      }
    })
    .build();
}

useEffect(() => {
  if (!isAuth) {
    connectionTimerHub?.stop();
    connectionUpdateHub?.stop();
    return;
  }

  const timerHub = connectHub(urlTimerHub, 'timer');
  const updateHub = connectHub(urlUpdateHub, 'update');

  const startConnections = async () => {
    try {
      await timerHub.start();
      await timerHub.invoke("Join", localStorage.getItem('userID'));
      console.log('TimerHub connected...');
      
      await updateHub.start();
      await updateHub.invoke("Join", localStorage.getItem('userID'));
      console.log('UpdateHub connected...');

      setConnectionTimerHub(timerHub);
      setConnectionUpdateHub(updateHub);

    } catch (error) {
      console.error('Connection failed:', error);
      setTimeout(startConnections, 5000);
    }
  };

  startConnections();

  return () => {
    timerHub?.stop();
    updateHub?.stop();
  };
}, [isAuth]);// eslint-disable-line react-hooks/exhaustive-deps
  /***************************/

  useEffect(() => {
    switch (location.pathname) {
      case '/':
        document.title = 'Мой день'
        break;
      case '/calendar':
        document.title = 'Календарь'
        break;
      case '/viewlist':
        document.title = 'Входящие задачи'
        break;
      case '/automation':
        document.title = 'Повторяющиеся задачи'
        break;
      case '/profile':
        document.title = 'Профиль'
        break;
      case '/settings':
        document.title = 'Настройки'
        break;
      case '/statistics':
        document.title = 'Статистика'
        break;
      case '/completed':
        document.title = 'Выполненные'
        break;
      case '/removed_todo':
        document.title = 'Корзина'
        break;
      case '/tags':
        document.title = 'Метки'
        break;
      case '/login':
        document.title = 'Вход - Timetask'
        break;
      case '/login/':
        document.title = 'Вход - Timetask'
        break;
      case '/register':
        document.title = 'Регистрация - Timetask'
        break;
      case '/forgot_password':
        document.title = 'Восстановление пароля'
        break;
      default:
        document.title = 'Timetask'
        break;
    }
  }, [location.pathname])

  useEffect(() => {
    const handleUpdateScreenWidth = () => {
      setWindowScreen(window.screen.width)
    }

    window.addEventListener('resize', handleUpdateScreenWidth);

    return () => {
      window.removeEventListener('resize', handleUpdateScreenWidth);
    };
  }, [windowScreen])

  useEffect(() => {
    arrayLink.map((item, index) => {
      if (item === location.pathname) {
        updatePageName({
          pageName: arrayPages[index].title,
          index: index
        })
      }
      return index;
    })
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [location.pathname])

  useEffect(() => {
    if (isAuth) {
      dispatch(getAvatar());
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [isAuth])

  useEffect(() => {
    if (isAuth) {
      request.get('/Settings/', {
        params: { UserId: localStorage.getItem('userID') }
      })
        .then((response) => dispatch(loadUserSettings(response.data)))
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [isAuth])
  const headerRef = useRef<HTMLElement>(null);
  
  const handleLogOut = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('authToken');
    localStorage.removeItem('liveRefreshUntil');
    localStorage.removeItem('userID');
    cookies.remove('accessToken');
    cookies.remove('refreshToken');
    localStorage.setItem('interceptorTry', 'false');
    dispatch({type: UserAuthActionTypes.FETCH_DATA_USER_ACCOUNT_LOGOUT})
    setTimeout(() => {
      navigate('/login')
    }, 500);
  }
  
  useEffect(() => {
      const accessToken = cookies.get('accessToken');
      const userID = localStorage.getItem('userID');
      if (accessToken && userID) {
        dispatch(getUserData())
      } else {
            handleLogOut();
      }
      /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [])

  const handleLoginPage = () => {
    navigate('/')
  }

  const handleRegisterPage = () => {
    navigate('/register')
  }
  

  if(loading) {
    return <div style={{display: 'flex', justifyContent:'center', alignItems: 'center', height: '100vh', width: '100wh'}}>
      <Loader />
      </div>
  }

  return (
    <>
    {isAuth ? (
      <>
        <header id="Head" className='header' ref={headerRef}>
          <img className='header__logo' alt='logo' src={logo} style={{ cursor: 'pointer' }} onClick={() => navigate('/', { require: true })} />
          <EPG date={ConverterUTC({method: 'object', settingsUser: userSettings})} />
          <ul className="header__menu">
          {windowScreen > 576 && <Feedback/>}
            {
              windowScreen > 576 ?
              <button ref={ref} className='btn-menu' onClick={() => setMenuActiv(!menuActiv)}>
                  <img className='user-avatar' src={avaUrl} alt='' />
                </button> :
                <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                  <div ref={refCloseSelectPage} className='pagePicker' onClick={() => setMenuPage(!menuPage)}>
                    <span className='pagePicker__span'>
                      {arraySvg[pageName.index]}
                      <p>{pageName.pageName}</p>
                      <ArrowDown className={menuPage ? 'rotated-arrow' : 'unrotated-arrow'} />
                    </span>
                  </div>
                    {
                      menuPage ?
                      <DDselectPage arrayPages={arrayPages}
                      arrayLink={arrayLink}
                      currentLocation={location.pathname}
                      updatePageName={updatePageName} /> : null
                    }
                  <div style={{display: 'flex', gap: '10px'}}>
                    <Feedback/>
                    <button ref={ref} className='btn-menu__mobile' onClick={() => setMenuActiv(!menuActiv)}>
                      <BurgerMenu style={{width: '16px', height: '16px'}}></BurgerMenu>
                    </button>
                  </div>
                </div>
            }
            {
              windowScreen > 576 ?
                <DDMenu
                  active={menuActiv}
                  avatar={avaUrl}
                
                  setActive={setMenuActiv}
                /> :
                <OffcanvasMobile 
                  active={menuActiv}
                
                  setActive={setMenuActiv}
                  avatar={avaUrl}
                />
            }
          </ul>
        </header>
        {/* <body> */}
        {
                modalShow &&
                <ModalWindow updateModalState={setModalShow}
                modalShow={modalShow}
                logo={true}
                position={'center'}
                disabledOutsideClose={true}
                disabledCloseBtn={true}
                title={'У вас изменился часовой пояс. Поменять его на новый?'}>
                    <div>
                        <p>Новый часовой пояс <span style={{fontWeight: 600}}>{getDetectedTimeZone()}</span> — его можно будет изменить в настройках</p>
                        <div  style={stylesForBtnDiv}>
                            <Button title={'Оставить прошлый'}
                                    loading={loadingDecline}
                                    btnType="default"
                                    
                                    onClickFunc={handleDeclineNewTimeZone}
                                    
                            /> 
                            <Button title={'Да, сделать новый'}
                                    loading={loadingAccept}
                                    btnType="filled"
                                    
                                    onClickFunc={handleAddNewTimeZone}
                                    
                            />
                        </div>
                    </div>
                </ModalWindow>
            }
          {/* {
            modalShow &&
            <ModalWindow updateModalState={updateModalState}
              modalShow={modalShow}
              title={titleModal}
              disabledCloseBtn={isDisabledCloseBtn}
              disabledOutsideClose={isDisabledOutsideClose}
              description={descriptionModal}
              logo={logoModal}
              buttons={buttonsModal} />
          } */}
          
        {/* </body> */}
        <div>
          <connectionHubContext.Provider value={{timerHub: connectionTimerHub, updateHub: connectionUpdateHub}}>
            <Routes element={<ProtectedRoutes />}>
              <Route path="/" element={<TodayTask setIcon={setEditTaskModalIcon} />} />
              <Route path="/task/:id" element={<><TodayTask setIcon={setEditTaskModalIcon} /><EditModalTask modalTitle={'Мой день'} /></>} />
              <Route path="/login/" element={<LoginPage/>} />
              <Route path="/register" element={<RegisterPage/>} />
              <Route path="/viewlist" element={<IncomingTodosPage setIcon={setEditTaskModalIcon} />} />
              <Route path="/viewlist/task/:id/" element={<><IncomingTodosPage setIcon={setEditTaskModalIcon} /><EditModalTask modalTitle={'Входящие задачи'} /></>} />
              <Route path="/completed" element={<CompletedTodosPage setIcon={setEditTaskModalIcon} />} />
              <Route path="/completed/task/:id/" element={<><CompletedTodosPage setIcon={setEditTaskModalIcon} /><EditModalTask disabled={true} modalTitle={'Выполненные'} /> </>} />
              <Route path="/calendar" element={<CalendarPage setIcon={setEditTaskModalIcon} />} />
              <Route path="/calendar/task/:id/" element={<><CalendarPage setIcon={setEditTaskModalIcon} /><EditModalTask modalTitle={'Календарь'} /> </>} />
              <Route path="/removed_todo" element={<DeletedTodosPage setIcon={setEditTaskModalIcon} />} />
              <Route path="/removed_todo/task/:id/" element={<><DeletedTodosPage setIcon={setEditTaskModalIcon} /><EditModalTask disabled={true} modalTitle={'Корзина'} /></>} />
              <Route path="/tags" element={<LabelPage />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/automation" element={<RepeatTemplatePage setIcon={setEditTaskModalIcon} />} />
              <Route path="/automation/task/:id/" element={<><RepeatTemplatePage setIcon={setEditTaskModalIcon} /><EditModalTask modalTitle={'Повторяющиеся задачи'} /> </>} />
              <Route path='/integrations' element={<Settings/>}></Route>
              <Route path="/oauth/callback/" element={<SuccessGoogle />} />
              <Route path='/profile' element={<Settings />} />
              <Route path='/test' element={<Settings />} />
              <Route path='/statistics' element={<Settings />} />
              <Route path='/statistics/task/:id/' element={<><Settings /><EditModalTask disabled={true} modalTitle={'Выполненные'} /></>} />
              <Route path="/*" element={<NotFoundPage />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path='/register_success' element={<SuccessPage title='Вы успешно зарегистрировались' typeIcon={1} />} />
            </Routes>
          </connectionHubContext.Provider>
        </div>
      </>
    ) : (
      <>
        <header className='header'>
          <img className='header__logo-nologin' alt='logo' src={logo} style={{ cursor: 'pointer' }} onClick={() => navigate('/', { require: true })} />
          {window.screen.width > 576 ?
            <div className='header__buttons' style={isDisabledHeaderBtns ? { display: 'none' } : { display: 'flex' }}>
              <Button title='Регистрация' onClickFunc={handleRegisterPage} btnType="default" btnSize="xl" />
              <Button title='Войти' onClickFunc={handleLoginPage} btnType="filled" btnSize="xl" />
            </div> : null}
        </header>
        <Routes>
          <Route path="/register" element={<RegisterPage/>} />
          <Route path="/login/" element={<LoginPage/>} />
          <Route path="/" element={<LoginPage/>} />
          <Route path="/forgot_password" element={<ForgotPassword />} />
          <Route path="/ResetPassword/" element={<ResetPassword />} />
          <Route path="/privacy" element={<Privacy />} />
          {prodHidden && <Route path='/auth/vk/callback/' element={<SuccessAuth typeAuth='vk'/>}/>}
          <Route path='/auth/yandex/callback/' element={<SuccessAuth typeAuth='yandex'/>}/>
          <Route path="/*" element={<NotFoundPage setIsDisabledHeaderBtns={setIsDisabledHeaderBtns} />} />
        </Routes>
      </>
    )
    }
    </>
  )
}

export default App;
